var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionResize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-60.000000, -971.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Resize",
    transform: "translate(60.000000, 971.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.933,17 L0,17 C0,19.246 1.821,21.066 4.067,21.066 L8.058,21.066 L0,29.124 L2.876,32 L10.933,23.942 L10.933,27.934 C10.933,30.179 12.754,32 15,32 L15,21.066 L15,17 L10.933,17 Z M17,10.933 L17,0 C19.246,0 21.066,1.821 21.066,4.067 L21.066,8.058 L29.124,0 L32,2.876 L23.942,10.933 L27.933,10.933 C30.179,10.933 32,12.754 32,15 L21.066,15 L17,15 L17,10.933 Z",
    id: 262
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionResize);
export default __webpack_public_path__ + "static/media/navigation-and-action-resize.6a481edd.svg";
export { ForwardRef as ReactComponent };